module.exports = __webpack_public_path__ + "static/media/audible.9a6a39ef.svg";